export default __webpack_public_path__ + "static/media/profile2.6b997837.png";